import { graphql } from '../../../shared/graphql';
import { GenerateStripeInvoicePreviewInput } from '../../../shared/graphql/graphql';
import execute from '../../../shared/helpers/functions/api';

export const generateStripeInvoicePreview = (
  input: GenerateStripeInvoicePreviewInput,
) => {
  const query = graphql(`
    mutation GenerateStripeInvoicePreview(
      $input: GenerateStripeInvoicePreviewInput!
    ) {
      generateStripeInvoicePreview(input: $input) {
        lines {
          priceId
          quantity
          periodStart
          periodEnd
          amount
        }
        currency
        subtotal
        tax
        total
        totalDiscountAmounts {
          amount
        }
      }
    }
  `);

  return execute({ query, variables: { input } });
};
